import { SheetCollapsibleIndustryOrSkillList } from "@/components/SheetCollapsibleIndustryOrSkillList";
import { SheetSectionEmptyText } from "@/components/SheetSectionEmptyText";
import { SkillType } from "@/types";

export const SkillsContent = ({ skills }: { skills: SkillType[] }) => {
  if (!skills.length) {
    return (
      <SheetSectionEmptyText text="This candidate hasn't added any skills yet." />
    );
  }

  return <SheetCollapsibleIndustryOrSkillList industriesOrSkills={skills} />;
};
